import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

// Utils
import { selectors } from '@src/shared/src';
// Constants
import { CONFIRM_TIMEOUT, FLEXLANE_CONTRACT_STATUS, STATUS } from '@src/shared/src/const/app';
// Interfaces
import { IRootState } from '@src/store';

// True while the confirmed booking is still waiting for its FlexLane cover to be created
// (lanes-planes/backend#15086). The contract step runs after the booking is confirmed, so without this the
// success overlay lands first and the "cover could not be added" message arrives on top of it.
//
// The backend omits flexlane_contract_status entirely for a booking FlexLane is not in play for (no eligible
// fare, org toggle off, a rebooking), so its absence means "do not wait" and those checkouts never pause.
export const useFlexLaneContractWait = () => {
  const basket = useSelector((state: IRootState) => selectors.checkout.basket(state.checkout));
  const [gaveUp, setGaveUp] = useState(false);

  const pending =
    basket?.status === STATUS.CONFIRM_FINISHED &&
    basket?.flexlaneContractStatus === FLEXLANE_CONTRACT_STATUS.PENDING;

  useEffect(() => {
    if (!pending) {
      // The single instance now lives for the whole checkout, so nothing remounts it back to false: without
      // this a give-up would silently disarm the wait for every later pending cycle.
      setGaveUp(false);
      return;
    }
    // Nothing else can end the wait: the outcome only ever arrives as a basket re-broadcast, so a lost
    // websocket or a Sidekiq queue that never drains would otherwise hold the customer here for good.
    const timer = setTimeout(() => setGaveUp(true), CONFIRM_TIMEOUT.FLEXLANE_CONTRACT);
    return () => clearTimeout(timer);
  }, [pending]);

  return pending && !gaveUp;
};
